<template>
  <v-container v-show="viewPage" fluid>
    <div class="text-h2">
      Comprar licencia
    </div>
    <v-row
      align="center"
      justify="center"
      v-for="product in products"
      :key="product.id"
    >
      <v-card v-if="product.visible === true" class="mx-auto" height="380">
        <v-list-item class="text-center">
          <v-list-item-content>
            <v-list-item-title class="headline font-weight-bold">
              {{ product.name }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-divider />

        <v-list-item class="text-center" two-line>
          <v-list-item-content>
            <v-list-item-title class="text-h2">
              ${{ product.price }}
            </v-list-item-title>
            <v-list-item-subtitle>
              <br />
              <p class="text-wrap">{{ product.description }}</p>
              <p>Licencia individual</p>
              <p>Duración: 12 meses</p>
              <p class="text-wrap">
                Acceso a los resultados de las 2 primeras evaluaciones, y/o
                veces en que el niño haya completado la evaluación, de cada
                nivel.
              </p>
              <p class="text-wrap">
                * Las compras serán procesadas de forma segura a través de Niubiz, empresa líder en el mercado peruano de procesamiento de pagos y operaciones financieras.
              </p>
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>

        <v-divider />

        <v-list-item
          class="text-center"
          align="center"
          justify="center"
          two-line
        >
          <v-checkbox
            v-model="checked"
            :label="`Acepto los términos y condiciones`"
            text
          >
          </v-checkbox>

          <v-btn
            class="primary mx-auto"
            @click="openMethosPayment(product)"
            :disabled="checked === false"
          >
            Comprar
          </v-btn>
        </v-list-item>

        <!-- <v-list-item class="text-center">
          <v-list-item-content>
            <v-list-item-title>
              <v-btn
                class="primary mx-auto"
                @click="openMethosPayment(product)"
                :disabled="checked===false"
              >
                Comprar
              </v-btn>
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item> -->
      </v-card>
    </v-row>

    <v-dialog v-model="dialog" width="500">
      <v-card>
        <v-card-title class="headline grey lighten-2">
          Comprar
        </v-card-title>

        <v-divider />

        <v-list-item three-line>
          <v-list-item-content>
            <div class="mb-4">
              {{ productSelected.name }}
            </div>
            <v-list-item-title class="headline mb-1">
              $ {{ productSelected.price }}
            </v-list-item-title>
            <!-- <v-list-item-subtitle>Gracias por su compra</v-list-item-subtitle> -->
          </v-list-item-content>
        </v-list-item>

        <v-list-item>
          <v-list-item-content>
            <v-progress-circular
              v-if="loading"
              :size="50"
              color="primary"
              :indeterminate="loading"
            />
            <div id="paypal-button-container" ref="refPaypal" />
          </v-list-item-content>
        </v-list-item>

        <v-card-actions>
          <v-spacer />
          <v-btn color="primary" text @click="dialog = false">
            Cancelar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <help-button :tutorial="tutorial" />
    <modal-button :tutorial="terms" :label="this.text" :button_style="1" />
  </v-container>
</template>

<script>
import HelpButton from "@/views/dashboard/pages/panel/HelpButton";
import ModalButton from "@/views/dashboard/pages/home/ModalButton";

import firebase from "firebase/app";
import axios from "axios";
import { mapMutations, mapState } from "vuex";
export default {
  components: {
    HelpButton,
    ModalButton
  },
  data() {
    return {
      checked: false,
      terms: "terms",
      text: "Términos y Condiciones",
      post: null,
      error: null,
      viewPage: false,
      tutorial: "shop-my-products",
      loading: false,
      uid: "",
      dialog: false,
      productSelected: {},
      purchase_units: [],
      addLicensesUrl:
        "https://us-central1-videojuego-sh.cloudfunctions.net/addLicenses"
    };
  },
  computed: {
    ...mapState(["products", "user"])
  },
  watch: {
    dialog(val) {
      val || (this.$refs.refPaypal.innerHTML = "");
    }
  },
  mounted() {
    this.uid = this.user.uid;
    let VisanetCheckoutScript = document.createElement("script");
    VisanetCheckoutScript.setAttribute("text", "text/javascript");
    VisanetCheckoutScript.setAttribute(
      "src",
      "https://static-content.vnforapps.com/v2/js/checkout.js"
    );
    document.head.appendChild(VisanetCheckoutScript);
  },
  methods: {
    setData(err, post) {
      if (err) {
        this.error = err.toString();
      } else {
        this.post = post;
      }
    },
    init() {
      const self = this;
      paypal
        .Buttons({
          createOrder: function(data, actions) {
            return actions.order.create({
              purchase_units: self.purchase_units
            });
          },
          onApprove: function(data, actions) {
            self.onApprove(data);
          },
          onCancel: function(data) {
            self.onCancel(data);
          },
          onError: function(error) {
            self.onError(error);
          }
        })
        .render("#paypal-button-container");
    },
    openMethosPayment(product) {
      // this.dialog = true
      this.$store.commit("SET_LOADING", true);
      this.$store.dispatch("CREATE_CHECKOUT", product.id).then(checkoutData => {
        if (checkoutData !== null) {
          VisanetCheckout.configure({
            sessiontoken: checkoutData.sessionToken,
            channel: checkoutData.channel,
            merchantid: checkoutData.merchantid,
            purchasenumber: checkoutData.purchaseNumber,
            amount: checkoutData.amount,
            expirationminutes: checkoutData.expirationminutes,
            timeouturl: checkoutData.timeouturl,
            merchantlogo: checkoutData.merchantlogo,
            formbuttoncolor: checkoutData.formbuttoncolor,
            action: `${checkoutData.action}?sessionToken=${checkoutData.sessionToken}&dev=false`
          });
          VisanetCheckout.open();
          this.$store.commit("SET_LOADING", false);
        } else {
          this.$store.commit("SET_LOADING", false);
        }
      });
      // setTimeout(() => {
      //     this.init()
      //     this.loadPaypal = false
      // }, 1000);
      // this.productSelected = product
      // this.purchase_units = [
      //   {
      //     amount: {
      //       currency_code: 'USD',
      //       value: product.price,
      //       description: product.name,
      //     },
      //   },
      // ]
    },
    onCancel(data) {
      console.log("Cancel", data);
    },
    onError(error) {
      console.error("Error", error);
    }
  },
  beforeRouteEnter(to, from, next) {
    //console.log("router: ", from.path, to.path, auth.currentUser);

    next(async vm => {
      const user = vm.user;
      if (user.type === "tutor" || user.type === "parent") {
        vm.viewPage = true;
        next();
      } else {
        console.log("Está intentando ingresar a una pagina no autorizada.");
        next({
          name: "Home"
        });
      }
    });
  }
};
</script>
